import { IconProps } from "@chakra-ui/react";

export type TwoToneIconProps = IconProps & {
  colorScheme?: string;
  primaryShade?: number;
  secondaryShade?: number;
};

type TwoToneChakraColors = {
  primaryColor: string;
  secondaryColor: string;
};

function getChakraColor(colorScheme: string, shade: number) {
  return `var(--chakra-colors-${colorScheme}-${shade})`;
}

/**
 * Extracts the two colors for a two-tone icon.
 * You must provide a valid chakra color scheme and shades.
 */
export function getTwoToneChakraColors({
  colorScheme,
  primaryShade,
  secondaryShade,
}: {
  colorScheme: string;
  primaryShade: number;
  secondaryShade: number;
}): TwoToneChakraColors {
  return {
    primaryColor: getChakraColor(colorScheme, primaryShade),
    secondaryColor: getChakraColor(colorScheme, secondaryShade),
  };
}
